import React from "react";
import { viewPostings } from "../../../actions/views";
import PostingItem from "./PostingItem";
import {getTranslation} from "../../../languages/language";

class PostingTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
    }

    componentDidMount() {
        viewPostings(this, this.props.app)
    }


    render() {
        const { app, lang } = this.props;
        return (
            <div>
                <table>
                    <thead>
                    <tr>
                        <th>{getTranslation(lang, "job_title", "info")}</th>
                        <th>{getTranslation(lang, "job_description", "info")}</th>
                        <th>{getTranslation(lang, "job_deadline", "info")}</th>
                        <th>{getTranslation(lang, "created_on", "info")}</th>
                        <th>{getTranslation(lang, "remove", "info")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.data.map(item => (
                        <PostingItem item={item} list={this} app={app}/>)
                    )}
                    </tbody>
                </table>
            </div>
        )

    }

}

export default PostingTable